import type { TFunction } from "i18next";
import PaginationControls from "../../../../../../components/base/PaginationControls";

interface TrailerPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  t: TFunction;
}

export function TrailerPagination({
  currentPage,
  totalPages,
  onPageChange,
}: TrailerPaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <PaginationControls
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
    />
  );
}
